import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Cms } from '@impact/data';

@Component({
    selector: 'app-payment-icon-list',
    template: `
        <ul class="payment-icon-list">
            <li *ngFor="let paymentIcon of list" class="payment-icon-list__item">
                <img class="payment-icon-list__item-icon" [src]="paymentIcon?.src | resolveMediaUrl: { format: 'webp', width: 50, height: 50 }" loading="lazy" width="50" height="50" />
            </li>
        </ul>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentIconListComponent {
    @Input() list?: Cms.Media[];
}
